import {motion} from 'framer-motion';
import React, {Component} from 'react';

interface IProps {
    collapsed?: boolean
    containerClassName?: string
    headerClassName?: string
    bodyClassName?: string
    header?: (collapsed: boolean, triggerCollapse: (collapse?: boolean) => void) => React.ReactElement
    delay?: number
    noRenderCollapsedContent?: boolean
    saveStateKey?: string
}

interface IState {
    collapsed: boolean
}

class Collapse extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            collapsed:  props.collapsed === undefined ? (props.saveStateKey ? !!localStorage.getItem(props.saveStateKey) : true) : props.collapsed
        }
    }

    componentDidUpdate(prevProps: IProps) {
        if (prevProps.collapsed !== this.props.collapsed) {
            this.setCollapsed(this.props.collapsed)
        }
    }

    saveCollapseState = () => {
        this.props.saveStateKey && localStorage.setItem(this.props.saveStateKey, this.state.collapsed ? '1' : '');
    }

    setCollapsed = (collapsed?: boolean) => {
        this.setState(state => ({collapsed: collapsed !== undefined ? collapsed : !state.collapsed}), this.saveCollapseState)
    }

    render() {
        const {header, children, headerClassName, containerClassName, bodyClassName, delay, noRenderCollapsedContent} = this.props
        const {collapsed} = this.state

        return <div className={containerClassName}>
            {header && (
                <div className={headerClassName}>
                    {header(collapsed, this.setCollapsed)}
                </div>
            )}
            <motion.div initial={{height: collapsed ? "0px" : "auto", display: collapsed ? "none" : "block"}}
                        transition={{duration: delay !== undefined ? delay : 0.5}}
                        className={'overflow-hidden ' + (bodyClassName || '')}
                        animate={{
                            height: collapsed ? "0px" : "auto",
                            transitionEnd: {display: collapsed ? "none" : "block"}
                        }}>
                {noRenderCollapsedContent && collapsed ? '' : children}
            </motion.div>
        </div>
    }
}

export default Collapse
